<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加企业')" class="search-btn">添加企业</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="warning" class="search-btn" @click="handlerdown">批量下线</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="用户名"
                prop="username"
                v-if="formValidate.Id == 0"
              >
                <Input
                  v-model="formValidate.username"
                  placeholder="请输入用户名"
                ></Input>

              </FormItem>
              <FormItem
                label="单位名称"
                prop="Cname"
              >
                <Input
                  v-model="formValidate.Cname"
                  placeholder="请输入单位名称"
                ></Input>
              </FormItem>
              <FormItem
                label="单位地址"
                prop="Caddress"
              >
                <Input
                  v-model="formValidate.Caddress"
                  placeholder="请输入单位地址"
                ></Input>
              </FormItem>
              <FormItem
                label="单位简介"
                prop="Cintroduce"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Cintroduce"
                  placeholder="请输入单位简介"
                ></Input>
              </FormItem>
              <FormItem label="法人代表" prop="Crepresentative">
                <Input
                  v-model="formValidate.Crepresentative"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系人" prop="Ccontacts">
                <Input
                  v-model="formValidate.Ccontacts"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系电话" prop="Cphone">
                <Input
                  v-model="formValidate.Cphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="统一社会信用代码" prop="Ccode">
                <Input
                  v-model="formValidate.Ccode"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="规模" prop="Cscale">
                <el-select
                  v-model="formValidate.Cscale"
                  filterable
                  default-first-option
                  placeholder="请选择规模">
                  <el-option
                    v-for="item in CscaleList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="行业" prop="Cindustry">
                <el-select
                  v-model="formValidate.Cindustry"
                  filterable

                  default-first-option
                  placeholder="请选择行业，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in CindustryList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="类型" prop="Ctype">
                <el-select
                  v-model="formValidate.Ctype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in CtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import {
  getCompanylist,
  operationCompany,
  operationCompanydown
} from '@/api/scinfo/scinfo.js'
import {
  patchuser,
  resetPassword
} from '@/api/user'
import {getsysparameterList} from '@/api/system/sys_parameter'

// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      CindustryList: [],
      CscaleList: [],
      CtypeList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
        Cname: [
          {
            required: true,
            message: '单位名字不能为空',
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'blur'
          }
        ],
        Ctype: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ],
        Cindustry: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ]

      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '用户名',
          key: 'username',
          width: 120,
          align: 'center',
          tooltip: 'true',
          fixed: 'left',
          sortable: true
        },
        {
          title: '单位名称',
          key: 'Cname',
          tooltip: 'true',
          align: 'center',
          width: 200,
          fixed: 'left',
          sortable: true
        },
        {
          title: '单位简介',
          key: 'Cintroduce',
          tooltip: 'true',
          align: 'center',
          width: 200,
          sortable: true
        },
        {
          title: '单位地址',
          key: 'Caddress',
          tooltip: 'true',
          align: 'center',
          width: 200,
          sortable: true
        },
        {
          title: '统一社会代码',
          key: 'Ccode',
          width: 200,
          tooltip: 'true',
          align: 'center',
          sortable: true
        },
        {
          title: '联系人',
          key: 'Ccontacts',
          tooltip: 'true',
          align: 'center',
          width: 120,
          sortable: true
        },
        {
          title: '联系电话',
          key: 'Cphone',
          width: 150,
          tooltip: 'true',
          align: 'center',
          sortable: true
        },
        {
          title: '在线状态',
          key: 'Cstate_CN',
          width: 120,
          fixed: 'right',
          align: 'center',
          sortable: true
        },
        {
          title: '状态',
          key: 'status',
          width: 80,
          fixed: 'right',
          align: 'center',
          render: (h, params, vm) => {
            return h('div', [
              h('i-switch', {
                props: {
                  // type: "primary",
                  value: params.row.status === '0' // 控制开关的打开或关闭状态，官网文档属性是value
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  'on-change': () => {
                    this.onSwitch(params)
                  }
                }
              })
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 220,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'put', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleResetPWD(params.row)
                    }
                  }
                },
                '重置密码'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }

        }
      ]
    }
  },
  methods: {

    handleResetPWD (value) {
      if (confirm(`确定要重置该用户的密码`)) {
        resetPassword({user_list: [value.user_info.user_id]}).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },

    // 获取TagTree
    onSwitch (editData) {
      const EditData = {
        user_id: editData.row.user_info.user_id,
        key: editData.column.key
      }
      patchuser(EditData).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getCompanylist (key, value) {
      this.spinShow = true
      getCompanylist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    getCscaleList () {
      getsysparameterList('company_info', 'Cscale').then(res => {
        if (res.data.code === 0) {
          this.CscaleList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },
    getCindustryList () {
      getsysparameterList('company_info', 'Cindustry').then(res => {
        if (res.data.code === 0) {
          this.CindustryList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getCtypeList () {
      getsysparameterList('company_info', 'Ctype').then(res => {
        if (res.data.code === 0) {
          this.CtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getCindustryList()
      this.getCtypeList()
      this.getCscaleList()
      if (paramsRow && paramsRow.Id) {
        this.formValidate = {
          Id: paramsRow.Id,
          Cname: paramsRow.Cname,
          Sbid: paramsRow.Sbid,
          Caddress: paramsRow.Caddress,
          Cintroduce: paramsRow.Cintroduce,
          Crepresentative: paramsRow.Crepresentative,
          Ccontacts: paramsRow.Ccontacts,
          Cphone: paramsRow.Cphone,
          Ccode: paramsRow.Ccode,
          Clicense: paramsRow.Clicense,
          Cindustry: paramsRow.Cindustry,
          Ctype: paramsRow.Ctype,
          Cstate: paramsRow.Cstate,
          Cuid: paramsRow.Cuid,
          username: paramsRow.username,
          Cscale: paramsRow.Cscale
        }
      } else {
        this.formValidate = {
          Id: 0,
          Cname: '',
          Sbid: '',
          Caddress: '',
          Cintroduce: '',
          Crepresentative: '',
          Ccontacts: '',
          Cphone: '',
          Ccode: '',
          Clicense: '',
          Cindustry: '',
          Ctype: '',
          Cstate: 0,
          Cuid: 0,
          username: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            operationCompany(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)

                if (this.searchVal) {
                  this.getCompanylist(this.searchVal)
                } else {
                  this.getCompanylist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },

    handleReset (name) {
      this.$refs[name].resetFields()
    },

    handlerdown () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量下线这些企业 `)) {
          operationCompanydown({'id_list': this.tableSelectIdList}, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getCompanylist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    handlerDelete () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中企业嘛？ `)) {
          operationCompany({'id_list': this.tableSelectIdList}, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getCompanylist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    // 删除
    delData (params) {
      if (confirm(`确定要删除 ${params.row.Cname}`)) {
        // console.log(params.row.id)
        operationCompany(
          {
            'Id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },

    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getCompanylist()
  }
}

</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
